module.exports = __webpack_public_path__ + "static/media/tech rider dance example 2 (stage plan).eeadc7de.docx";